import { Box, InputAdornment, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styles from './createVideo.module.scss';
import { useMemo } from 'react';
import { UPDATE_DRAFT_EVENT } from '../../constants/actionTypes';
import { connect } from 'react-redux';
import { TextField } from '../../core/components';
import { getCurrencyByCountry } from './utils';

const mapDispatchToProps = (dispatch) => ({
    onUpdateDraftEvent: (payload) => dispatch({ type: UPDATE_DRAFT_EVENT, payload })
});
const SetPrice = (props) => {
    const { t } = useTranslation();

    const handlePriceChange = (e) => {
        const value = e.target.value;
        if (/^\d*([.,]?\d*)$/.test(value)) {
            props.setPrice(value);
            props.setPriceError('');
        }
    };

    const currency = props?.currency?.toUpperCase();

    return (
        <>
            <Typography fontSize={'28px'} sx={{ lineHeight: '100%', letterSpacing: '-0.56px' }}>
                {t('PriceExplanation')}
            </Typography>
            <Box className={styles.uploadContent}>
                <Box className={styles.priceContent}>
                    <TextField
                        label={t('SetYourPrice')}
                        type="text"
                        value={props.price}
                        onChange={handlePriceChange}
                        onBlur={(e) => {
                            if (e.target.value !== '') {
                                props.onUpdateDraftEvent({ price: e.target.value });
                            }
                        }}
                        onFocus={() => props.setPriceError('')}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Typography
                                        fontSize={'16px'}
                                        sx={{ lineHeight: 'normal', letterSpacing: '-0.32px' }}
                                        color={'#6C6C6C'}>
                                        {currency}
                                    </Typography>
                                </InputAdornment>
                            )
                        }}
                        fullWidth
                    />
                    {/* {props.priceError && <Typography color={'red'}>{props.priceError}</Typography>} */}
                    {props.minimumPrice > 0 && currency && (
                        <Typography
                            fontSize={'13px'}
                            sx={{
                                marginTop: '1rem',
                                lineHeight: 'normal',
                                letterSpacing: '-0.13px'
                            }}
                            color={'#6C6C6C'}
                            textAlign={'center'}>
                            {t('MinimumPrice', {
                                minimumPrice: `${props.minimumPrice} ${currency}`
                            })}
                        </Typography>
                    )}
                </Box>
            </Box>
        </>
    );
};

export default connect(null, mapDispatchToProps)(SetPrice);
